<template>
  <div>
    <div class="header-card">
      <!-- <div class="close-btn">
        <img src="@/assets/close.png" height="18" width="18" alt="close-icon" @click="close">
      </div> -->
      <div class="header-card-text">
        <h3>Subscribe</h3>
      </div>
    </div>

    <div class="content">
      <p class="cabin-family text-center" v-if="!subscriberStatus">Annual subscription fee
        payment is required to proceed.</p>
      <p class="cabin-family text-center" v-else>Your Annual subscription has expired, kindly
        make payment to renew your Subscription.</p>
      <button @click="initializePaystack" class="btn primary-btn btn-block mb-10">
        <span v-if="!loading"> Pay Locally </span>
            <vue-loaders-ball-spin-fade-loader scale=".5" v-else>
            </vue-loaders-ball-spin-fade-loader>
      </button>

      <button @click="openEcwid" class="btn primary-btn btn-block">
        <span> Pay Outside Nigeria </span>
      </button>

      <div class="investments" v-if="balance > 0 || myInvestments.length > 0">
        <div class="account_balance">
          <p class="cabin-family" style="margin-bottom: 0.25rem">Wallet Balance</p>
          <p class="balance cabin-family bold">₦ {{ Number(balance).toLocaleString() }}</p>
        </div>

        <h3 class="cabin-family">Your Investments</h3>
         <div v-if="myInvestments.length >= 1">
          <div class="investment-card" v-for="(inv, index) in myInvestments" :key="index"
          @click="openInvestment('t', inv.id)">
            <div class="first-col">
            <p class="cabin-family bold">{{ inv.investment.company }} - {{ inv.investment.name }}
            </p>
              <p v-if="inv.investment.percentage > 0" class="black">
              <span class="bold primary">{{inv.investment.percentage}}%</span> in
              {{ inv.investment.duration }} months</p>
              <p class="cabin-family">
              <span class="bold">
              <span v-if="inv.investment.denomination == 'Naira'">₦</span>
              <span v-else>$</span>
              {{ Number(inv.amount).toLocaleString() }}</span></p>
              <p class="cabin-family" v-if="matured(inv.maturity_date)">
              <span class="bold primary">Matured</span></p>
              <p class="sub-text primary" v-if="inv.investment.denomination == 'Dollar'">
              **USD investments are currently calculated at ₦500/$1</p>
            </div>
            <div class="second-col">
            </div>
          </div>
        </div>
        <div v-else class="empty">
          <h5 class="secondary cabin-family">Investments Not available</h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      subscriptionStatus: false,
      subscriberStatus: false,
      errorMsg: false,
      loading: false,
      myInvestments: [],
      balance: 0,
    };
  },
  mounted() {
    this.checkSubscription();
    this.getWallet();
    this.getInvestments();
  },
  methods: {
    async initializePaystack() {
      this.loading = true;
      const user = JSON.parse(localStorage.getItem('user'));
      const url = `${this.$baseUrl}/paystack/initialize`;
      const data = {
        email: user.email,
      };
      const response = await this.$http({ url, data, method: 'POST' });
      this.loading = false;
      window.location.href = response.data.paymentUrl;
    },

    openEcwid() {
      window.open('https://thesmartstewards.ecwid.com/Annual-Subscription-of-The-Smart-Investment-Club-Outside-Nigeria-p180093666', '_blank');
    },

    async getInvestments() {
      const url = `${this.$baseUrl}/user/investments`;
      const res = await this.$http({ url, method: 'GET' });
      this.myInvestments = res.data.transactions;
    },

    async getWallet() {
      const url = `${this.$baseUrl}/wallet`;
      const res = await this.$http({ url, method: 'GET' });
      this.balance = res.data.balance || 0;
      this.roi = res.data.roi || 0;
      this.invested = res.data.invested || 0;
      localStorage.setItem('balance', this.balance);
      // console.log(this.userBank);
    },
    matured(matDate) {
      const currentDate = new Date();
      const maturityDate = new Date(matDate);
      if (currentDate >= maturityDate) {
        return true;
      }
      return false;
    },
    async checkSubscription() {
      const url = `${this.$baseUrl}/subscription/check`;
      const response = await this.$http({ url, method: 'GET' });
      this.subscriptionStatus = response.data.check;
      this.subscriberStatus = response.data.subscriber;
      localStorage.setItem('userSubscription', this.subscriptionStatus);
      if (this.subscriptionStatus === true) {
        this.$router.push('/');
      } else {
        this.errorMsg = true;
      }
    },
    close() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.mb-10{
  margin-bottom: 1rem;
}
.account_balance{
  margin: 2rem 0;
}
.empty{
    text-align: center;
    margin: 4rem auto;
  }
</style>
